import { BettingStructure, PokerCategory, PokerVariant, Prisma, Transaction, Waitlist } from '@repo/database/src/types';
import { subMinutes } from 'date-fns';

import { userPublic } from '../user/user.dto';
import { ComputedGameParams } from './game-params.dto';

// in minutes
export const waitlistJoinCountdownDuration = 1;

export const tableWaitlistArgs = () =>
  ({
    select: {
      userId: true,
    },
    where: {
      OR: [
        { attemptJoiningAt: null },
        { attemptJoiningAt: { gte: subMinutes(new Date(), waitlistJoinCountdownDuration) } },
      ],
    },
    distinct: ['userId'],
  }) satisfies Prisma.Table$waitlistArgs;

export const tableWithSeats = {
  include: {
    seats: {
      include: {
        user: {
          ...userPublic,
        },
      },
    },
    waitlist: tableWaitlistArgs(),
  },
} satisfies Prisma.TableDefaultArgs;

export type TableWithSeats = Omit<Prisma.TableGetPayload<typeof tableWithSeats>, 'waitlist' | 'category'> & {
  waitlist: string[];
  category: PokerCategory;
};

export class TableResponseDto {
  tables: AdminTableInfoDto[];
  totalCount: number;
  skip: number | undefined;
  take: number | undefined;
}

export type AdminTableInfoDto = Omit<TableWithSeats, 'waitlist'> & {
  seatCount: number;
  waitlist: number;
  waitlists: Waitlist[];
};
export type TableInfoDto = TableWithSeats & {
  players: number;
  waitlist: string[];
  bettingStructure: BettingStructure;
  isRealNameTable: boolean;
};

export type TableDetailsDto = TableInfoDto & {
  gameParams: ComputedGameParams[];
  transactions: Transaction[];
  transactionsCount: number;
  uncollectedRake: number;
};

export type PublicTableDto = Omit<TableInfoDto, 'variants'> & {
  variants: PokerVariant[];
  gameParams: ComputedGameParams[];
  currentVariantIndex: number;
};

export class TableInfoResponseDto {
  tables: PublicTableDto[];
  total: number;
}
